import { AttachmentDto, TrackingAttachmentDto } from 'src/models/attachment';

/**
 * Builds a stable key for a document selection and row identity.
 * Prefers document id and falls back to file name when id is missing.
 */
export const getDocumentSelectionKey = (
  document: AttachmentDto | TrackingAttachmentDto,
  fileName: string
): string => {
  return document.id ?? fileName;
};

/**
 * Is document currently selected.
 *
 * - Document is selected if its key is present in the selectedDocuments array.
 *
 * @param val string;
 * @param selectedDocuments Array<string>
 * @returns boolean
 */
export const documentIsSelected = (val: string, selectedDocuments: Array<string>): boolean => {
  return selectedDocuments.includes(val);
};
